export default class DashboardSalesman extends HTMLDivElement {
    constructor() {
        super();
    }

    getUrlParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    buildUrlWithParams(baseUrl, params) {
        const urlParams = new URLSearchParams();

        Object.keys(params).forEach(key => {
            if (params[key] !== null && params[key] !== undefined) {
                urlParams.append(key, params[key]);
            }
        });

        const queryString = urlParams.toString();

        return queryString ? `${baseUrl}?${queryString}` : baseUrl;
    }

    connectedCallback() {
        let _this = this;

        $('#DashboardSalesman').on('change.select2', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            const url = $('#dashboard-select-parent').data('url');
            const selectedValue = e.currentTarget.value;
            const redirectUrl = _this.buildUrlWithParams(url, {
                client: _this.getUrlParameter('client'),
                commercial: selectedValue
            });

            location.href = redirectUrl;
        });
    }
}